function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React, { memo } from 'react';
import styled from 'styled-components';
import { borderRadius, boxShadow } from 'styled-system';
import Box from './Box';
import theme from './theme';
const StyledOverlayContent = styled(Box).withConfig({
  displayName: "OverlayContent__StyledOverlayContent",
  componentId: "sc-1lfq578-0"
})(["", " ", ""], borderRadius, boxShadow);
const OverlayContent = /*#__PURE__*/memo(_ref => {
  let {
    bg = theme.colors.gray[1],
    borderRadius = 'corner',
    boxShadow = 'hover',
    children,
    mx = 'auto',
    my = rem(80),
    p = [3, 4],
    width = '95%',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledOverlayContent, _extends({
    bg: bg,
    borderRadius: borderRadius,
    boxShadow: boxShadow,
    mx: mx,
    my: my,
    p: p,
    width: width
  }, props), children);
});
OverlayContent.propTypes = {
  ...Box.propTypes,
  ...borderRadius.propTypes,
  ...boxShadow.propTypes
};
OverlayContent.displayName = 'OverlayContent';
export default OverlayContent;